var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 101,
    height: 101,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hourglass",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M57.483,36.906,40.914,22.7a3.415,3.415,0,0,1-1.182-2.567V20H32.977v.135A3.416,3.416,0,0,1,31.794,22.7l-16.569,14.2a16.914,16.914,0,0,0-5.894,12.82v.558c11.924-.93,13.038-6.638,27.023-6.638s15.1,5.709,27.023,6.638v-.558A16.918,16.918,0,0,0,57.483,36.906Z",
    transform: "translate(14.309 30.668)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M63.378,4.667v9.12a16.972,16.972,0,0,1-2.888,9.458H12.22a16.958,16.958,0,0,1-2.888-9.458V4.667Z",
    transform: "translate(14.309 7.156)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M63.378,35.971v8.563H9.332V35.971c11.924-.93,13.038-6.638,27.023-6.638S51.454,35.042,63.378,35.971Z",
    transform: "translate(14.309 44.98)",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M37.984,32.132v.135H31.228v-.135a3.415,3.415,0,0,0-1.182-2.567l-16.569-14.2A17.167,17.167,0,0,1,10.471,12h48.27a17.188,17.188,0,0,1-3.007,3.361l-16.568,14.2A3.415,3.415,0,0,0,37.984,32.132Z",
    transform: "translate(16.057 18.401)",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M66.444,35.333a5.067,5.067,0,1,1,0,10.134H12.4a5.067,5.067,0,0,1,0-10.134Z",
    transform: "translate(11.242 54.18)",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M66.444.667a5.067,5.067,0,0,1,0,10.134H12.4A5.067,5.067,0,0,1,12.4.667Z",
    transform: "translate(11.242 1.022)",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M36.354,20v.135A3.415,3.415,0,0,1,35.172,22.7L18.6,36.906a16.913,16.913,0,0,0-5.894,12.82v.135c-.321.05-.642.118-.98.152-.2.034-.422.068-.642.084-.557.068-1.149.135-1.757.186v-.558a16.914,16.914,0,0,1,5.894-12.82L31.794,22.7a3.416,3.416,0,0,0,1.183-2.567V20Z",
    transform: "translate(14.309 30.668)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M15.6,23.245H12.22a16.958,16.958,0,0,1-2.888-9.458V4.667h3.378v9.12A16.956,16.956,0,0,0,15.6,23.245Z",
    transform: "translate(14.309 7.156)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M12.709,31.787v8.985H9.332V32.209c.608-.051,1.2-.119,1.757-.186.219-.016.439-.05.642-.084C12.068,31.9,12.388,31.837,12.709,31.787Z",
    transform: "translate(14.309 48.742)",
    fill: "#ee8700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M34.606,32.132v.135H31.228v-.135a3.415,3.415,0,0,0-1.182-2.567l-16.569-14.2A17.167,17.167,0,0,1,10.471,12h3.378a17.167,17.167,0,0,0,3.006,3.361l16.569,14.2A3.416,3.416,0,0,1,34.606,32.132Z",
    transform: "translate(16.057 18.401)",
    fill: "#ee8700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M15.776,45.467H12.4a5.067,5.067,0,0,1,0-10.134h3.378a5.067,5.067,0,1,0,0,10.134Z",
    transform: "translate(11.242 54.18)",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M15.776,10.8H12.4A5.067,5.067,0,0,1,12.4.667h3.378a5.067,5.067,0,1,0,0,10.134Z",
    transform: "translate(11.242 1.022)",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M69.153,88.065V80.393a18.546,18.546,0,0,0-6.489-14.106L46.1,52.085a1.688,1.688,0,0,1-.59-1.281v-.271a1.685,1.685,0,0,1,.59-1.283l16.566-14.2a18.554,18.554,0,0,0,6.489-14.108V13.272A6.742,6.742,0,0,0,67.464,0H13.418a6.742,6.742,0,0,0-1.689,13.272v7.671a18.546,18.546,0,0,0,6.489,14.106l16.567,14.2a1.688,1.688,0,0,1,.59,1.281V50.8a1.691,1.691,0,0,1-.59,1.283l-16.567,14.2a18.556,18.556,0,0,0-6.489,14.108v7.671a6.742,6.742,0,0,0,1.689,13.271H67.464a6.742,6.742,0,0,0,1.689-13.271ZM15.107,82.471a34.317,34.317,0,0,0,10.809-3.236A30.674,30.674,0,0,1,40.441,76a30.679,30.679,0,0,1,14.525,3.233,34.317,34.317,0,0,0,10.809,3.236v5.354H15.107ZM10.04,6.756a3.378,3.378,0,0,1,3.378-3.378H67.464a3.378,3.378,0,0,1,0,6.756H13.418A3.378,3.378,0,0,1,10.04,6.756Zm5.067,6.756H65.775v7.431a15.191,15.191,0,0,1-2.133,7.769h-46.4a15.176,15.176,0,0,1-2.134-7.769Zm5.308,55.34,16.566-14.2A5.063,5.063,0,0,0,38.752,50.8v-.271a5.052,5.052,0,0,0-1.771-3.845l-16.566-14.2c-.145-.123-.274-.263-.414-.393H60.877c-.142.13-.269.27-.415.395l-16.567,14.2a5.063,5.063,0,0,0-1.765,3.847V50.8a5.055,5.055,0,0,0,1.77,3.845l16.567,14.2A15.158,15.158,0,0,1,65.7,79.064a31.317,31.317,0,0,1-9.369-2.915,33.894,33.894,0,0,0-15.892-3.524,33.9,33.9,0,0,0-15.893,3.524,31.306,31.306,0,0,1-9.369,2.915A15.166,15.166,0,0,1,20.416,68.851ZM67.464,97.958H13.418a3.378,3.378,0,0,1,0-6.756H67.464a3.378,3.378,0,0,1,0,6.756Z",
    transform: "translate(10.222 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M19.331,21.333H22.71v3.378H19.331Z",
    transform: "translate(29.643 32.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M19.331,24H22.71v3.378H19.331Z",
    transform: "translate(29.643 36.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M19.331,26.667H22.71v3.378H19.331Z",
    transform: "translate(29.643 40.891)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.917a66772a54e2cc2b5c7b15a865781c.svg";
export { ForwardRef as ReactComponent };